import { createFileRoute } from '@tanstack/react-router'
import { NaukriCandidateDetail } from '@/features/naukri-candidate-detail'

export const Route = createFileRoute('/_authenticated/naukri-candidates/$id/')({
  component: NaukriCandidateDetail,
})
